(() => {
  const selector = '[data-bluno-deferred-video]';
  const load = (frame) => {
    const template = frame.querySelector('template[data-bluno-video-template]');
    if (!template) return;
    frame.appendChild(template.content.cloneNode(true));
    template.remove();
  };
  const init = (root) => {
    const frames = root.querySelectorAll(selector);
    if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
      frames.forEach(load);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        load(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px' });
    frames.forEach((frame) => observer.observe(frame));
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
